function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, ref, computed, reactive, watch, getCurrentInstance } from "vue";
import TableList from "@/components/TableList/index.vue";
import Pagination from "@pt/views/pt-entry/components/pagination/index.vue";
import AddAssistAccountDialog from "./add-assist-account-dialog.vue";
import _ from "lodash";
import isMaterialWarehouse from "@/common/is-warehouse";
import { getAssistantsList, addAssistant, deleteAssistant } from "@pt/api/user/index";
import { getAdvertiserAssistantsList, addAdvertiserAssistant, deleteAdvertiserAssistant } from "@/api/advertiser/manage";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 0
        }
    },
    components: {
        TableList: TableList,
        Pagination: Pagination,
        AddAssistAccountDialog: AddAssistAccountDialog
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var addAssistAccountDialogVisible = ref(false);
        var query = reactive({
            page_size: 10,
            page: 1
        });
        var list = ref([]);
        var loading = ref(false);
        var tableTotal = ref(0);
        var addLoading = ref(false);
        var tableColumnConfig = computed(function() {
            return [
                {
                    label: root.$t("playTurbo.authAccount.assistAccountDialog.table.name"),
                    prop: "assistant_name"
                },
                {
                    slot: "type-cell"
                },
                {
                    slot: "action-cell"
                }, 
            ];
        });
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var handleClose = function() {
            emit("update:visible", false);
            query.page_size = 10;
            query.page = 1;
            list.value = [];
            tableTotal.value = 0;
            loading.value = false;
        };
        var handleOpenDialog = function() {
            addAssistAccountDialogVisible.value = true;
        };
        var handelSubmit = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(assistant_name) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            addLoading.value = true;
                            if (!isMaterialWarehouse()) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 5;
                            return addAdvertiserAssistant({
                                id: props.id,
                                assistant_name: assistant_name
                            });
                        case 5:
                            _ctx.next = 9;
                            break;
                        case 7:
                            _ctx.next = 9;
                            return addAssistant({
                                id: props.id,
                                assistant_name: assistant_name
                            });
                        case 9:
                            root.$message.success(String(root.$t("playTurbo.authAccount.addAssistAccountDialog.successMessage")));
                            initList();
                            addLoading.value = false;
                            addAssistAccountDialogVisible.value = false;
                            _ctx.next = 18;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            addLoading.value = false;
                        case 18:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function handelSubmit(assistant_name) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleDelete = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(row) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            loading.value = true;
                            if (!isMaterialWarehouse()) {
                                _ctx.next = 7;
                                break;
                            }
                            _ctx.next = 5;
                            return deleteAdvertiserAssistant({
                                id: row.id
                            });
                        case 5:
                            _ctx.next = 9;
                            break;
                        case 7:
                            _ctx.next = 9;
                            return deleteAssistant({
                                id: row.id
                            });
                        case 9:
                            root.$message.success(String(root.$t("playTurbo.authAccount.delete.success.message")));
                            initList();
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            loading.value = false;
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function handleDelete(row) {
                return _ref.apply(this, arguments);
            };
        }();
        var handleSizeChange = function(pageSize) {
            query.page_size = pageSize;
            initList();
        };
        var handleCurrentChange = function(page) {
            query.page = page;
            initList();
        };
        function initList() {
            return _initList.apply(this, arguments);
        }
        function _initList() {
            _initList = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var params, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            params = _objectSpreadProps(_objectSpread({}, _.pick(query, [
                                "page_size",
                                "page"
                            ])), {
                                id: props.id
                            });
                            loading.value = true;
                            ;
                            if (!isMaterialWarehouse()) {
                                _ctx.next = 10;
                                break;
                            }
                            _ctx.next = 7;
                            return getAdvertiserAssistantsList(params);
                        case 7:
                            res = _ctx.sent;
                            _ctx.next = 13;
                            break;
                        case 10:
                            _ctx.next = 12;
                            return getAssistantsList(params);
                        case 12:
                            res = _ctx.sent;
                        case 13:
                            if (res.data.code === 0) {
                                list.value = _.get(res, "data.data.list") || [];
                                tableTotal.value = _.get(res, "data.data.total") || 0;
                                loading.value = false;
                            }
                            _ctx.next = 19;
                            break;
                        case 16:
                            _ctx.prev = 16;
                            _ctx.t0 = _ctx["catch"](0);
                            loading.value = false;
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        16
                    ]
                ]);
            }));
            return _initList.apply(this, arguments);
        }
        watch(function() {
            return props.visible;
        }, function(val) {
            if (val) {
                console.log("isMaterialWarehouse", isMaterialWarehouse());
                initList();
            }
        }, {
            immediate: true
        });
        return {
            query: query,
            dialogVisible: dialogVisible,
            list: list,
            loading: loading,
            tableTotal: tableTotal,
            tableColumnConfig: tableColumnConfig,
            addAssistAccountDialogVisible: addAssistAccountDialogVisible,
            addLoading: addLoading,
            initList: initList,
            handleClose: handleClose,
            handleOpenDialog: handleOpenDialog,
            handleDelete: handleDelete,
            handelSubmit: handelSubmit,
            handleSizeChange: handleSizeChange,
            handleCurrentChange: handleCurrentChange,
            isMaterialWarehouse: isMaterialWarehouse
        };
    }
});
